import { render, staticRenderFns } from "./sendpulse_general_tab.vue?vue&type=template&id=5f6aad49&scoped=true&"
import script from "./sendpulse_general_tab.vue?vue&type=script&lang=js&"
export * from "./sendpulse_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6aad49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6aad49')) {
      api.createRecord('5f6aad49', component.options)
    } else {
      api.reload('5f6aad49', component.options)
    }
    module.hot.accept("./sendpulse_general_tab.vue?vue&type=template&id=5f6aad49&scoped=true&", function () {
      api.rerender('5f6aad49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/sendpulse/location/tabs/sendpulse_general_tab.vue"
export default component.exports